import * as React from 'react'

export const DashboardIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0 3C0 1.90625 0.875 1 2 1H14C15.0938 1 16 1.90625 16 3V13C16 14.125 15.0938 15 14 15H2C0.875 15 0 14.125 0 13V3ZM2 5V13H7V5H2ZM14 5H9V13H14V5Z"
        fill="currentColor"
      />
    </svg>
  )
}
